import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  crmWalletEnabled: true,
  maxShops: 1,
  maxBranchesPerShop: 5,
};

const featureToggleSlice = createSlice({
  name: "featureToggle",
  initialState,
  reducers: {
    setCrmWalletEnabled: (state, action) => {
      state.crmWalletEnabled = action.payload;
    },
    setMaxShops: (state, action) => {
      state.maxShops = action.payload;
    },
    setMaxBranchesPerShop: (state, action) => {
      state.maxBranchesPerShop = action.payload;
    },
  },
});

export const { setCrmWalletEnabled, setMaxShops, setMaxBranchesPerShop } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;